
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * ClientReportsGetLastIdResponse struct
 */
class ClientReportsGetLastIdResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!number=} recordId
   * @constructor
   */
  constructor (parent = new Response(), recordId = new UInt64(0, 0)) {
    super()
    super.copy(parent)
    this.recordId = recordId
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ClientReportsGetLastIdResponse}
   * @param {!ClientReportsGetLastIdResponse} other Other struct
   * @returns {!ClientReportsGetLastIdResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.recordId != null) {
      this.recordId = UInt64.fromNumber(other.recordId)
    } else {
      this.recordId = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ClientReportsGetLastIdResponse}
   * @returns {!ClientReportsGetLastIdResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ClientReportsGetLastIdResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ClientReportsGetLastIdResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ClientReportsGetLastIdResponse}
   * @param {!ClientReportsGetLastIdResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientReportsGetLastIdResponse)) {
      throw new TypeError('Instance of ClientReportsGetLastIdResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ClientReportsGetLastIdResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      recordId: ((this.recordId != null) ? this.recordId.toNumber() : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ClientReportsGetLastIdResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ClientReportsGetLastIdResponse} other Object value
   * @returns {!ClientReportsGetLastIdResponse} Created struct
   */
  static fromObject (other) {
    return new ClientReportsGetLastIdResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ClientReportsGetLastIdResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ClientReportsGetLastIdResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ClientReportsGetLastIdResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3035
  }
}

export { ClientReportsGetLastIdResponse };

/**
 * Fast Binary Encoding ClientReportsGetLastIdResponse field model
 */
class FieldModelClientReportsGetLastIdResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.recordId = new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.recordId.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.recordId.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelClientReportsGetLastIdResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3035
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.recordId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.recordId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.recordId.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {!ClientReportsGetLastIdResponse} fbeValue Default value, defaults is new ClientReportsGetLastIdResponse()
   * @returns {!ClientReportsGetLastIdResponse} ClientReportsGetLastIdResponse value
   */
  get (fbeValue = new ClientReportsGetLastIdResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {!ClientReportsGetLastIdResponse} fbeValue ClientReportsGetLastIdResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.recordId.fbeSize) <= fbeStructSize) {
      fbeValue.recordId = this.recordId.get()
    } else {
      fbeValue.recordId = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.recordId.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {!ClientReportsGetLastIdResponse} fbeValue ClientReportsGetLastIdResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelClientReportsGetLastIdResponse}
   * @param {ClientReportsGetLastIdResponse} fbeValue ClientReportsGetLastIdResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.recordId.set(fbeValue.recordId)
  }
}

export { FieldModelClientReportsGetLastIdResponse };

/**
 * Fast Binary Encoding ClientReportsGetLastIdResponse model
 */
class ClientReportsGetLastIdResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelClientReportsGetLastIdResponse(this.buffer, 4)
  }

  /**
   * Get the ClientReportsGetLastIdResponse model
   * @this {!ClientReportsGetLastIdResponseModel}
   * @returns {!FieldModelClientReportsGetLastIdResponse} model ClientReportsGetLastIdResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ClientReportsGetLastIdResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ClientReportsGetLastIdResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ClientReportsGetLastIdResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ClientReportsGetLastIdResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelClientReportsGetLastIdResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ClientReportsGetLastIdResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ClientReportsGetLastIdResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ClientReportsGetLastIdResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ClientReportsGetLastIdResponseModel}
   * @param {!ClientReportsGetLastIdResponse} value ClientReportsGetLastIdResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ClientReportsGetLastIdResponseModel}
   * @param {!ClientReportsGetLastIdResponse} value ClientReportsGetLastIdResponse value, defaults is new ClientReportsGetLastIdResponse()
   * @return {!object} Deserialized ClientReportsGetLastIdResponse value and its size
   */
  deserialize (value = new ClientReportsGetLastIdResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ClientReportsGetLastIdResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ClientReportsGetLastIdResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ClientReportsGetLastIdResponseModel}
   * @param {!number} prev Previous ClientReportsGetLastIdResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ClientReportsGetLastIdResponseModel };
